import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import '@fontsource/roboto';
import { InfoLabel } from 'app/components/SHLabel';
import SHdropdown, { DropDownModel } from 'app/components/SHdropdown';
import { TextField } from 'app/components/TextField';
import { BackNextButton } from 'app/components/BackNextButton';
import { CheckBox } from 'app/components/CheckBox';
import SearchButton from 'app/components/SearchButton';
import CircularLoader from 'app/components/CircularLoader';
import {
  GeneralLookup,
  GeneralLookupWrapper,
  RidersWrapper,
} from 'services/openapi';
import SimpleReactValidator from 'simple-react-validator';
import { periviousValue } from 'app/pages/RiderRegistrationPage/components/staticData';
import { Button } from '@progress/kendo-react-buttons';
import { useNavigate } from 'react-router-dom';
import { useRiderRegistrationApi } from 'hooks/useRiderRegistrationApi';
import RiderTable from 'app/pages/RiderRegistrationPage/components/ReturningRider/components/RiderTable';

type Props = {
  handleNextForm?: (event) => void;
  handleBackForm?: (event) => void;
  backNumber?: string;
  setBackNumber: React.Dispatch<React.SetStateAction<string>>;
  lookUp?: GeneralLookupWrapper[];
  riderTableData?: RidersWrapper;
  setRidertableData: React.Dispatch<
    React.SetStateAction<RidersWrapper | undefined>
  >;
  isChecked: boolean;
  handleCheckboxClick: (riderId: string) => void;
  checkedMap: null;
  categoryDefaultDatas: GeneralLookup[] | undefined;
  seasonId: string | undefined;
  setSeasonValue: React.Dispatch<
    React.SetStateAction<GeneralLookup | undefined>
  >;
  seasonValue: GeneralLookup | undefined;
  filteredSeasonLookupData: GeneralLookup[];
  setIsChecked: React.Dispatch<React.SetStateAction<boolean>>;
  setCheckedMap: React.Dispatch<React.SetStateAction<null>>;
  isLookupLoading: boolean
};

const RetriveReturningMemberDataForm = ({
  categoryDefaultDatas,
  seasonId,
  setSeasonValue,
  seasonValue,
  handleNextForm,
  handleBackForm,
  backNumber,
  setBackNumber,
  lookUp,
  riderTableData,
  setRidertableData,
  handleCheckboxClick,
  isChecked,
  checkedMap,
  filteredSeasonLookupData,
  setIsChecked,
  setCheckedMap,
  isLookupLoading
}: Props) => {
  const navigate = useNavigate();
  const {
    getRidersList,
    riderSearchList,
    loading,
  } = useRiderRegistrationApi();
  const simpleValidator = React.useRef(new SimpleReactValidator());
  const searchedBy: DropDownModel[] = [
    // { id: 1, text: 'Team/Category/Division' },
    { id: 2, text: 'Back Number' },
    { id: 3, text: 'Name' },
  ];
  const [showTable, setShowTable] = useState<boolean>(false);
  const [lookUpShow, setLookUpShow] = useState(false);
  const [backNumberShow, setBackNumberShow] = useState(true);
  const [nameShow, setNameShow] = useState(false);
  const [defaultDropDownValue, setDefaultDropDownValue] =
    useState<DropDownModel>({ id: 2, text: 'Back Number' });
  const [nameValue, setNameChange] = useState('');
  const [isName, setIsName] = useState(false);
  const [isBackNumberCheck, setIsBackNumberCheck] = useState<boolean | null>(
    null,
  );
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);

  const selectSreachedby = e => {
    setIsChecked(true);
    setDefaultDropDownValue(e);
    setShowTable(false);
    setTeamValue(periviousValue);
    setCategoryValue(periviousValue);
    setDivisionChange(periviousValue);
    setBackNumber('');
    setNameChange('');
    simpleValidator.current.hideMessages();

    // Reset validation states
    setIsBackNumberCheck(null);
    setIsName(false);

    if (e.id === 1) {
      // Search by Team/Category/Division
      setLookUpShow(true);
      setBackNumberShow(false);
      setNameShow(false);
      setIsName(false);
    } else if (e.id === 2) {
      // Search by Back Number
      setBackNumberShow(true);
      setLookUpShow(false);
      setNameShow(false);
      setIsName(false);
      setIsBackNumberCheck(null); // Reset to null initially
    } else {
      // Search by Name
      setNameShow(true);
      setLookUpShow(false);
      setBackNumberShow(false);
      setIsName(true); // Initially invalid (true = invalid) until user enters name
    }
  };

  const [teamValue, setTeamValue] = useState<GeneralLookup>();
  const [categoryValue, setCategoryValue] = useState<GeneralLookup>();
  const [categoryDefaultValue, setCategoryDefaultValue] =
    useState<GeneralLookup>();
  const [divisionDatas, setDivisionDatas] = useState<GeneralLookup[]>();
  const [divisionValue, setDivisionChange] = useState<GeneralLookup>();
  const [categoryDatas, setCategoryDatas] = useState<GeneralLookup[]>();
  const [forceUpdate, setForceUpdate] = useState(false);

  const seasonChange = e => {
    setSeasonValue(e);
    setCategoryDatas(e.children);
    setTeamValue(periviousValue);
    setCategoryValue(periviousValue);
    setDivisionChange(periviousValue);
    setBackNumber('');
    setNameChange('');
    simpleValidator.current.hideMessages();
    setForceUpdate(!forceUpdate);
  };

  const teamChangeData = e => {
    setTeamValue(e);
  };

  const onDivisionChange = e => {
    setDivisionChange(e);
  };

  const onCategoryChange = e => {
    setCategoryValue(e);
    setCategoryDefaultValue(e);
    setDivisionDatas(e.children);
  };

  const showMessagesForFields = (fields: string[]): boolean => {
    let messagesShown = false;

    fields.forEach(field => {
      simpleValidator.current.showMessageFor(field);

      // Check if field is invalid
      if (simpleValidator.current.fields[field] === false) {
        messagesShown = true;
      }
    });
    // FORCE RE-RENDER to display messages!
    setForceUpdate(!forceUpdate);
    return messagesShown;
  };

  const handleSearchClick = (
    seasonId: string,
    backNumber: string,
    riderName: string,
    categoryId: string,
    divisionId: string,
    teamId: string,
  ) => {
    let fieldsToValidate: string[] = [];

    if (defaultDropDownValue?.id === 2) {
      fieldsToValidate = ['Back Number(3 or 4 digits)'];
    } else if (defaultDropDownValue?.id === 3) {
      fieldsToValidate = ['Name'];
    }

    const messagesShown = showMessagesForFields(fieldsToValidate);

    if (messagesShown) return;

    // Clear previous validation messages
    simpleValidator.current.hideMessages();

    getRidersList(
      seasonId,
      backNumber,
      riderName,
      categoryId,
      divisionId,
      teamId,
      undefined,
      1,
      10,
    );
    setShowTable(true);
    setCheckedMap(null);
    setIsChecked(true);
    setCurrentPage(1);
  };

  const handlePageChange = (newPage: number, newPageSize: number) => {
    setCurrentPage(newPage);
    setPageSize(newPageSize);
    getRidersList(
      seasonValue?.id! ? seasonValue?.id! : seasonId!,
      backNumber!,
      nameValue,
      categoryValue?.id!
        ? categoryValue?.id!
        : categoryDefaultValue?.id!,
      divisionValue?.id!,
      teamValue?.id!,
      undefined,
      newPage,
      newPageSize,
    );
  };

  const handleBackNumberChange = e => {
    const inputValue = e.target.value;
    if (inputValue.length <= 4 && /^\d*$/.test(inputValue)) {
      setBackNumber(inputValue);
    }
    if (inputValue.length >= 3) {
      setIsBackNumberCheck(false);
    } else {
      setIsBackNumberCheck(true);
    }
  };

  useEffect(() => {
    if (riderSearchList) {
      setRidertableData(riderSearchList);
    }
  }, [riderSearchList]);

  return (
    <MainWrapper className="form-MainWrapper" id="PersonalInfoFormMainWrapper">
      {isLookupLoading ? (
        <CircularLoader showText={true} />
      ) : (
        <>
          <SubMainWrapper className="SubMainWrapper">
            <BorderWrapper className="inner-BorderWrapper">
              <InfoLabelWrapper id="InfoLabelWrapper">
                <p className="Team-Heading">Returning Member</p>
                <div>
                  <InfoLabel>
                    Payment of $20 fee and proof of insurance must be
                    accompanied with this form
                  </InfoLabel>
                </div>
              </InfoLabelWrapper>
              <TextFieldGrid className="TextFieldGrid">
                <TextFieldWrapper>
                  <SHdropdown
                    className="drop-down"
                    label="Season"
                    data={filteredSeasonLookupData}
                    defaultValue={
                      seasonValue
                        ? seasonValue
                        : lookUp
                          ?.find(obj => {
                            return obj.type === 'SEASON';
                          })
                          ?.values?.find(item => item.isAdminLive === true) ??
                        undefined
                    }
                    onDataChange={event => {
                      seasonChange(event);
                    }}
                  />
                </TextFieldWrapper>
                <TextFieldWrapper>
                  <SHdropdown
                    className="drop-down"
                    label="Searched by"
                    genericData={searchedBy}
                    genericDefaultValue={defaultDropDownValue}
                    onGeneralDataChange={event => {
                      selectSreachedby(event);
                    }}
                  />
                </TextFieldWrapper>
                {lookUpShow && (
                  <>
                    {' '}
                    <TextFieldWrapper>
                      <SHdropdown
                        className="drop-down"
                        label="Team"
                        data={
                          lookUp?.find(obj => {
                            return obj.type === 'TEAM';
                          })?.values ?? []
                        }
                        onDataChange={event => {
                          teamChangeData(event);
                        }}
                        defaultValue={teamValue}
                      />
                    </TextFieldWrapper>
                    <TextFieldWrapper>
                      <SHdropdown
                        className="drop-down"
                        label="Category"
                        data={
                          categoryDatas ? categoryDatas : categoryDefaultDatas
                        }
                        onDataChange={event => {
                          onCategoryChange(event);
                        }}
                        defaultValue={categoryValue}
                      />
                    </TextFieldWrapper>
                    <TextFieldWrapper>
                      <SHdropdown
                        className="drop-down"
                        label="Division"
                        data={divisionDatas}
                        onDataChange={event => {
                          onDivisionChange(event);
                        }}
                        defaultValue={divisionValue}
                      />
                    </TextFieldWrapper>
                  </>
                )}
                {backNumberShow && (
                  <>
                    <TextFieldWrapper>
                      <StyledTextField
                        label="Back Number(3 or 4 digits)"
                        type="text"
                        name="backNumber"
                        value={backNumber}
                        onChange={handleBackNumberChange}
                        validations={'required|min:3|max:4'}
                        validator={simpleValidator.current}
                      />
                    </TextFieldWrapper>
                  </>
                )}
                {nameShow && (
                  <>
                    <TextFieldWrapper>
                      <StyledTextField
                        label="Name"
                        type="text"
                        name="name"
                        value={nameValue}
                        onChange={e => {
                          setNameChange(e.target.value);
                          setIsName(e.target.value.trim() === '');
                        }}
                        validations={'required|max:40'}
                        validator={simpleValidator.current}
                      />
                    </TextFieldWrapper>
                  </>
                )}
              </TextFieldGrid>
              <MainAddressWrapper>
                <SearchButtonWrapper>
                  <Button
                    className="main-btn-back"
                    onClick={() => {
                      navigate('/rider-registration-page');
                    }}
                  >
                    Back
                  </Button>
                  <SearchButton
                    onClick={() =>
                      handleSearchClick(
                        seasonValue?.id! ? seasonValue?.id! : seasonId!,
                        backNumber!,
                        nameValue,
                        categoryValue?.id!
                          ? categoryValue?.id!
                          : categoryDefaultValue?.id!,
                        divisionValue?.id!,
                        teamValue?.id!,
                      )
                    }
                  >
                    Search
                  </SearchButton>
                </SearchButtonWrapper>
                {showTable ? (
                  <TableButtonWrapper>
                    <RiderTable
                      riderTableData={
                        riderTableData?.riders && riderTableData.riders.length > 0
                          ? riderTableData.riders
                          : []
                      }
                      handleCheckboxClick={handleCheckboxClick}
                      checkedMap={checkedMap}
                      total={riderTableData?.pageDetails?.count ?? 0}
                      pageNumber={currentPage}
                      pageSize={pageSize}
                      onPageChange={handlePageChange}
                      isLoading={loading}
                    />
                    <InfoWrapper>
                      <p className="para-heading">
                        <i>PLEASE NOTE:</i>
                      </p>
                      <p className="para-content">
                        You are able to edit and update information in Returning
                        Member Registration.
                      </p>
                    </InfoWrapper>
                  </TableButtonWrapper>
                ) : (
                  ''
                )}
              </MainAddressWrapper>
            </BorderWrapper>
          </SubMainWrapper>
          {showTable ? (
            <BottomRightWrapper id="BottomRightWrapper">
              <ButtonWrapper>
                <BackNextButton
                  classNameBack="btn-back"
                  classNameNxt="btn-nxt"
                  onClickBack={handleBackForm}
                  onClickNxt={handleNextForm}
                  next="Next"
                  back="Cancel"
                  disableNext={isChecked}
                />
              </ButtonWrapper>
            </BottomRightWrapper>
          ) : (
            ''
          )}
        </>
      )}
    </MainWrapper>
  );
};

export default RetriveReturningMemberDataForm;

const MainWrapper = styled.div`
  color: #9597a6;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow: auto;
  position: relative;
  .Team-Heading {
    margin: 0px;
    padding: 0px 0px 20px !important;
    text-align: center;
    color: #9597a6;
  }
  ::-webkit-scrollbar {
    width: 5px;
    margin-left: 3px;
  }
  ::-webkit-scrollbar-track {
    background: transparent !important;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    width: 9px;
    background: transparent !important;
    border-radius: 10px;
  }
  .first-para,
  label {
    font-family: 'Roboto';
    font-size: 14px;
  }
  @media (min-width: 992px) and (max-width: 1199px) {
    .first-para,
    label {
      font-size: 12px;
    }
  }
  @media (min-width: 1200px) and (max-width: 1365px) {
    .first-para,
    label {
      font-size: 13px;
    }
  }
  @media (min-width: 1366px) and (max-width: 1448px) {
    .first-para,
    label {
      font-size: 14px;
    }
  }
`;

const SubMainWrapper = styled.div`
  height: calc(100vh - 150px);
  width: 100%;
`;

const BorderWrapper = styled.div`
  height: 100%;
  overflow: auto;
  border-radius: 20px;
  padding: 20px 60px 0px 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  ::-webkit-scrollbar {
    width: 5px;
    margin-left: 3px;
  }
  ::-webkit-scrollbar-track {
    background: transparent !important;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    width: 9px;
    background: #201e1e !important;
    border-radius: 10px;
  }
  @media (min-width: 100px) and (max-width: 575px) {
    padding: 10px 5px 0px 5px;
  }
  @media (min-width: 320px) and (max-width: 575px) {
    padding: 10px 10px 0px;
  }
`;

const InfoLabelWrapper = styled.div`
  padding: 0 20px 10px 20px;
  text-align: start;
  width: 100%;
  div {
    border-bottom: 1px solid #434343;
    padding: 6px 0;
  }
`;

const TextFieldGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  padding: 35px 0 0;
`;

const TextFieldWrapper = styled.div`
  width: 50% !important;
  margin-bottom: 20px;
  &.styled-TextFieldWrapper {
    display: grid;
    align-items: end;
  }
  @media (min-width: 100px) and (max-width: 767.98px) {
    width: 100% !important;
  }
  @media (min-width: 992px) and (max-width: 1199px) {
    width: 50% !important;
  }
`;

const StyledTextField = styled(TextField)`
  flex: 0 0 50%;
  &.styled-field {
    margin-bottom: 0px !important;
  }
`;

const SearchButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0px 30px;
  .main-btn-back {
    background-color: #2a2a2a;
    border: 1px solid #606060;
    color: #909090;
    height: 35px;
    &.light {
      background-color: #ededed;
    }
    &.dark {
      background-color: #2a2a2a;
    }
  }
  button {
    width: 100px;
    height: 30px;
    margin: 0px 10px;
    border-radius: 20px;
    background: #5b5a5a;
    border: 1px solid #8b8b8b;
  }
`;

const InfoWrapper = styled.div`
  width: 100%;
  border: 1px solid #585858;
  border-radius: 10px;
  margin: 30px 0px 20px;
  padding: 2px 20px;
  background: #27292d;
  .para-heading {
    color: #ff9900;
    border-bottom: 1px solid #5d5c5c;
    font-size: 14px;
  }
  .para-content {
    font-family: 'Roboto';
    color: #a7a7a7;
    font-size: 12px;
    padding: 10px 0px;
  }

  @media (min-width: 100px) and (max-width: 319px) {
    .para-content {
      font-size: 10px;
    }
  }
  @media (min-width: 320px) and (max-width: 575px) {
    .para-content {
      font-size: 10px;
    }
  }
  @media (min-width: 576px) and (max-width: 1199px) {
    .para-content {
      font-size: 11px;
    }
  }
  @media (min-width: 1200px) and (max-width: 1719px) {
    .para-content {
      font-size: 12px;
    }
  }
  @media (min-width: 1720px) and (max-width: 4000px) {
    .para-content {
      font-size: 13px;
    }
  }
`;

const MainAddressWrapper = styled.div`
  margin-bottom: 50px;
  padding: 0 0 50px 0;
  width: 100%;
  .horizontal-line {
    display: flex;
    align-items: baseline;
    margin: 20px 20px 15px 20px;
  }
  .horizontal-line span {
    margin: 0 10px 0 0;
    white-space: nowrap;
    color: #4f4f4f;
    font-size: 15px;
  }
  .horizontal-line::after {
    content: '';
    flex-grow: 1;
    border-top: 1px solid #434343;
    height: 3px;
  }
`;

const TableButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .k-grid-content {
    ::-webkit-scrollbar {
      width: 2px;
      margin-left: 3px;
      height: 10px;
    }
    ::-webkit-scrollbar-track {
      background: transparent !important;
      border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb {
      width: 2px;
      background: #201e1e !important;
      border-radius: 10px;
    }
  }
`;

const BottomRightWrapper = styled.div`
  z-index: 1;
  height: 100px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0px 0px 20px 20px;
  backdrop-filter: blur(10px);
  position: absolute;
  bottom: 0;
  &.bg-color {
    background: rgb(42 42 42) 100%;
  }
  &.bg-color-change {
    /* position: absolute;
    bottom: 40px;
    padding-top: 30px;
    background: linear-gradient(
      to bottom,
      rgb(48 48 48 / 79%) 0%,
      rgb(42 42 42) 100%
    ); */
  }
  @media (min-width: 992px) and (max-width: 1199px) {
    height: 40px;
    &.bg-color-change {
      bottom: 25px;
    }
  }
  @media (min-width: 1200px) and (max-width: 1365px) {
    height: 45px;
    &.bg-color-change {
      bottom: 30px;
      padding-top: 20px;
    }
  }
  @media (min-width: 1366px) and (max-width: 1448px) {
    height: 60px;
    &.bg-color-change {
      bottom: 20px;
      padding-top: 20px;
    }
  }
`;

const ButtonWrapper = styled.div``;